
import React, { FC, memo, useEffect, useMemo, useRef, useState } from "../../../lib/teact/teact";
import Button from "../../ui/Button";
import TabList from "../../ui/TabList";
import store from "../store";
import { login, updateLastScreen } from "../redux/loginSlice";
import { LotScreenSettings } from "../config/uiconfig";
import NhapTinNhan from "../message/nhapTinNhan";
import { DebounceKhopTin,  FetchAllChatAndSaveToLocal, FetchAllMessageAndSaveToLocal, GetAllMesssagesForParse, LuuTrongTinNhan, MarkAllmessagesNotParsed, MarkMessageParsed, SendTeleMessage } from "../tdlib/tdlib";
import DropdownMenu from "../../ui/DropdownMenu";
import MenuItem from "../../ui/MenuItem";
import LotSelect from "../ui/lotSelect";
import { dateToDateString,  dateToTimeString,  getCurrentTime, getCurrentTimeMillis, getDateString, getDateTimeString, secondsToDate } from "../utils/DateTimeUtils";
import Parser from "../restapi/parser";
import Snackbar from "../ui/snackbar";
import TeleMessages from "./teleMessages";
import { selectChat } from "../../../global/selectors";
import { getActions, getGlobal } from "../../../global";
import { DEBUG } from "../../../config";
import Loading from "../ui/loading";
import "../ui/formCommon.scss";
import ConfirmDialog from "../../ui/ConfirmDialog";
import LotCheckBox from "../ui/lotCheckBox";

import { LotMessage, TeleMessageToSend } from "../types/types";
import FilterMessage from "./filterMessage";
import TongHopDaiSelect from "./TongHopDaiSelect";
import { GetLoaiCuocIdsFromGroups, groupCuoc } from "./TongHopType";
import { ChangeEvent } from "react";
import { updateMessagesFirstLoad } from "../db/teleDb";
import { updateEditedMessageId, updateWorkDate } from "../redux/global";
import TongHopPage from "./TongHopPage";
import { ReportType, selectReport, updateRptDetailsData } from "../redux/TongHopSlice";
import { RptNhanVeParamsType, TongHopReport } from "../restapi/tongHopReport";
import TeleChatList from "../message/teleChatList";
import { ApiMessage } from "../../../api/types";
import { GetMienCuPhapID, GetUserFullInfo, GetUserID, ReplaceMultipleSpaces, ValidTextChuyen, debounce, hasRightGetTestMessage, isCuPhapMn, isLocalMode } from "../utils/common";
import useConnectionStatus, { ConnectionStatus } from "../../../hooks/useConnectionStatus";
import useLang from "../../../hooks/useLang";

import { subscribe, isSupported } from 'on-screen-keyboard-detector';
import './mainworking.scss'
import { GetContactsToSend } from "./CanChuyenData";
import ThamSoCanChuyen from "./ThamSoCanChuyen";
import { CanChuyen } from "../restapi/canChuyen";
import ListDataCanChuyen from "./ListDataCanChuyen";
import { GiuLaiNgoaiLe, buildDiemByStt, buildGiuLaiNgoaiLe, buildSms, initGiuLaiNgoaiLe, sortDataCanChuyen } from "./CanChuyenLib";
import SendMessages from "./SendMessages";
import { BuildSMSTraLaiMB } from "../utils/buildSMS";
import { ParseAndSaveMessageLocal } from "../db/service/parserService";
import { globalDexieDb } from "../db/DexiedbLib";
import { GenerateDataForTestMb } from "../db/service/testTool";
import { clearMessages, updateNotiMessage } from "../redux/notiSlice";
import TotalreportAll from "../reports/CongNo/totalreportAll";

import { ApiResult } from "../db/report/localBackend";
import PhoneConvs from "../message/phoneConvs";
import { sleep } from "../../../lib/gramjs/Helpers";
import DialogCatChuyenDi from "./dialogCatChuyenDi";
import worker from "../setupWorker";
import One789main from "../one789/one789main";

import MyDateInput from "../ui/myDateInput";

import DialogGetTestMessage from "../message/dialogGetTestMessage";
import DialogGetParsedMessage from "../message/dialogLayTinPhanTichLai";
import { AdminApi } from "../restapi/adminApi";

import { syncTelebotMessages } from "../tdlib/tdlibemulator";
export type OwnProps = {
    isActive: boolean;
    onChangeScreen: (screen: LotScreenSettings) => void;
    menuAction: string;

};
const MainWorking: FC<OwnProps> = ({
    isActive,
    onChangeScreen,
    menuAction,
}) => {
    const parseLockRef = useRef(false);
    const parseSessionRef = useRef(0);
    const {
        sendMessage
    } = getActions();
    const global = getGlobal()
    const lang = useLang()
    const { connectionStatus,
        connectionStatusPosition,
        connectionStatusText } = useConnectionStatus(lang, global.connectionState, true, true)
    const userFullInfo = GetUserFullInfo();
    // if (DEBUG) {
    //     switch (connectionStatus) {
    //         case ConnectionStatus.online:
    //             console.log(`ConnectionStatus.online`)
    //             break;
    //         case ConnectionStatus.syncing:
    //             console.log(`ConnectionStatus.syncing`)
    //             break;
    //         case ConnectionStatus.waitingForNetwork:
    //             console.log(`ConnectionStatus.waitingForNetwork`)
    //             break;
    //     }
    // }
    const TABS = [
        { type: 'abc', title: 'Xử lý' },
        { type: 'documents', title: 'Tổng hợp' },
        { type: 'links', title: 'Cân chuyển' },
        { type: 'links', title: 'Tin nhắn' },
        { type: 'links', title: 'one789' },

    ];
    const tabs = useMemo(() => ([
        ...TABS,
    ]), [/* hasCommonChatsTab, hasMembersTab, isChannel, topicId */]);
    // const [activeTab, setActiveTab] = useState(2);
    // const [tabData, setTabData] = useState({ msg: "" });
    const tongHopSlice = store.getState().tongHopSlice;
    const loginState = store.getState().login;;
    const [state, setState] = useState({
        activeTab: 0,
        tabData: [],
        messages: [],//LotMessage
        messagesFull: [],
        messageIndex: 0,
        workDate: store.getState().global.workDate,
        snackbarOpen: false,
        snackbarMessage: "",
        curMien: isCuPhapMn() ? "NAM" : "BAC",
        teleMessagesOpen: false,
        filterMessagesOpen: false,
        parsing: false,
        filter: "",
        settingOpen: false,
        settingDateType: 1, //1: ngày tin nhắn, 2 ngày tự đặt
        loaiBoTinTrung: 1, //1: tin trùng nội dung tuyệt đối chỉ lấy 1 lần
        deleteDialogOpen: false,
        getTestMessageDialogOpen: false,
        getParsedMessageDialogOpen: false,
        parseStatusMessageToLoad: 0, //0: chưa pt, 1 đã pt,2 tất cả
        sourceActiveSettingDialog: 0,// 0 bấm vào cài đặt tham số phân tích, 1 bấm vào nút save
        khongHoiLai: false,
        autoReadMessageAfterParse: false,
        xuLyChieuTinNhan: 'ALL' as 'ALL' | 'DI' | 'DEN', //ALL, DI, DEN        khongHoiLai: false,
        filterCondition: { title: "", content: "", date: store.getState().global.workDate },
        TongHopState: {
            groupSelected: initGroupSelected(), daiSelected: [] as string[], contactId: 0,
        },
        daiQuayTrongNgay: [] as string[],
        selectedReport: "NhanVe" as ReportType,
        reportPayload: { data: [] as any[] } as any,
        reportTotalAllData: {} as ApiResult, //map key = contactId
        isLoading: false,
        showLuuTrongDialog: false,
        CC: {
            sendTo: -1 as number,
            groupSelected: initGroupSelectedCC(), daiSelected: [] as string[],
            contactList: [] as any[],
            showThamSo: false,// tab 2c,3c,4c,da
            activeTab: 0,
            sendMessagesOpen: false,
            messages: [] as string[],
            showCatDi: false,
        },
        SaveCCParamTrigger: "",
        dataCanChuyen: getInitDataCanChuyen(),
        textChuyen: "100%",
        one789: {
            IdToken: '',
            ExpireTimeStamp: getCurrentTimeMillis(),
            mapResult: new Map<string, any>(),
            giaTran: 705,
        },
        deleteDateFrom: store.getState().global.workDate,
        deleteDateTo: store.getState().global.workDate,
        messageDirection: 1,
    });
    function initGroupSelected() {
        const savedStr = localStorage['groupSelected']
        if (savedStr) {
            const savedObj = JSON.parse(savedStr)
            if (savedObj)
                return savedObj;
        }
        return groupCuoc;
    }
    function saveState() {
        // Chỉ lưu cấu hình nhẹ, không lưu messages/report data để tránh bùng RAM khi stringify.
        const persistedState = {
            activeTab: state.activeTab,
            workDate: state.workDate,
            curMien: state.curMien,
            settingDateType: state.settingDateType,
            loaiBoTinTrung: state.loaiBoTinTrung,
            parseStatusMessageToLoad: state.parseStatusMessageToLoad,
            khongHoiLai: state.khongHoiLai,
            autoReadMessageAfterParse: state.autoReadMessageAfterParse,
            xuLyChieuTinNhan: state.xuLyChieuTinNhan,
            filterCondition: state.filterCondition,
            TongHopState: state.TongHopState,
            selectedReport: state.selectedReport,
            CC: {
                sendTo: state.CC.sendTo,
                groupSelected: state.CC.groupSelected,
                daiSelected: state.CC.daiSelected,
                showThamSo: state.CC.showThamSo,
                activeTab: state.CC.activeTab,
                showCatDi: state.CC.showCatDi,
            },
            textChuyen: state.textChuyen,
            one789: {
                giaTran: state.one789.giaTran,
            },
            deleteDateFrom: state.deleteDateFrom,
            deleteDateTo: state.deleteDateTo,
            messageDirection: state.messageDirection,
        };
        localStorage['mainworkingState'] = JSON.stringify(persistedState);
    }
    function initGroupSelectedCC() {
        const savedStr = localStorage['groupSelectedCC']
        if (savedStr) {
            const savedObj = JSON.parse(savedStr)
            if (savedObj)
                return savedObj;
        }
        return groupCuoc;
    }
    function handleOne789StateChanged(newState: any) {
        const tmp = { ...state.one789, ...newState };
        setState(prev => ({ ...prev, one789: tmp }))

    }
    function getMienDaiCuocId(curMien?: string): number {
        let m = state.curMien
        if (curMien)
            m = curMien
        switch (m) {
            case "NAM":
                return 3;
            case "TRUNG":
                return 2;
            case "BAC":
                return 1;
        }
        return 0
    }
    function handleDaiSelected(dai: string, e: ChangeEvent<HTMLInputElement>): void {
        if (e.target!.checked) {
            if (state.TongHopState.daiSelected.includes(dai)) {

            } else {
                const tmp = state.TongHopState.daiSelected;
                tmp.push(dai);
                setState((prev: any) => {
                    const tmpTongHop = prev.TongHopState;
                    tmpTongHop.daiSelected = tmp;
                    const newState = {
                        ...prev, TonHopState: tmpTongHop
                    }
                    return newState;
                })
            }
        } else {
            let tmp = state.TongHopState.daiSelected;
            tmp = tmp.filter(it => {
                return it != dai;
            })
            setState((prev: any) => {
                const tmpTongHop = prev.TongHopState;
                tmpTongHop.daiSelected = tmp;
                const newState = {
                    ...prev, TonHopState: tmpTongHop
                }
                return newState;
            })
        }
    }
    function handleTongHopContactIdChange(contactId: number) {
        setState((prev: any) => {
            const tmpTongHop = prev.TongHopState;
            tmpTongHop.contactId = contactId;
            const newState = { ...prev, TongHopState: tmpTongHop }
            return newState;
        }
        )
    }
    function handleCCDaiSelected(dai: string, e: ChangeEvent<HTMLInputElement>): void {
        if (e.target!.checked) {
            if (state.CC.daiSelected.includes(dai)) {

            } else {
                const tmp = state.CC.daiSelected;
                tmp.push(dai);
                setState((prev: any) => {
                    const tmpCC = prev.CC;
                    tmpCC.daiSelected = tmp;
                    const newState = {
                        ...prev, CC: tmpCC
                    }
                    return newState;
                })
            }
        } else {
            let tmp = state.CC.daiSelected;
            tmp = tmp.filter(it => {
                return it != dai;
            })
            setState((prev: any) => {
                const tmpCC = prev.CC;
                tmpCC.daiSelected = tmp;
                const newState = {
                    ...prev, CC: tmpCC
                }
                return newState;
            })
        }
    }
    function handleGroupCuocSelected(group: string, e: ChangeEvent<HTMLInputElement>): void {
        if (e.target.checked) {
            if (state.TongHopState.groupSelected.includes(group)) {

            } else {
                const tmp = state.TongHopState.groupSelected;
                tmp.push(group);
                setState((prev: any) => ({
                    ...prev,
                    TongHopState: { ...prev.TongHopState, groupSelected: tmp }

                }))
                // lưu lại trạng thái các nhóm đã chọn
                localStorage['groupSelected'] = JSON.stringify(tmp);
            }
        } else {
            let tmp = state.TongHopState.groupSelected;
            tmp = tmp.filter(it => {
                return it != group;
            })
            setState((prev: any) => ({
                ...prev,
                TongHopState: { ...prev.TongHopState, groupSelected: tmp }

            }))
            // lưu lại trạng thái các nhóm đã chọn
            localStorage['groupSelected'] = JSON.stringify(tmp);
        }

    }
    function handleCCGroupCuocSelected(group: string, e: ChangeEvent<HTMLInputElement>): void {
        if (e.target.checked) {
            if (state.CC.groupSelected.includes(group)) {

            } else {
                const tmp = state.CC.groupSelected;
                tmp.push(group);
                setState((prev: any) => ({
                    ...prev,
                    CC: { ...prev.CC, groupSelected: tmp }

                }))
                // lưu lại trạng thái các nhóm đã chọn
                localStorage['groupSelectedCC'] = JSON.stringify(tmp);
            }
        } else {
            let tmp = state.CC.groupSelected;
            tmp = tmp.filter(it => {
                return it != group;
            })
            setState((prev: any) => ({
                ...prev,
                CC: { ...prev.CC, groupSelected: tmp }

            }))
            // lưu lại trạng thái các nhóm đã chọn
            localStorage['groupSelectedCC'] = JSON.stringify(tmp);
        }
    }
    function hanldeDaiLoaded(dais: string[]) {
        setState(prev => ({
            ...prev,
            daiQuayTrongNgay: dais,
            TongHopState: { ...prev.TongHopState, daiSelected: dais },
        }))
    }
    function hanldeCCDaiLoaded(dais: string[]) {
        setState(prev => ({ ...prev, daiQuayTrongNgay: dais, CC: { ...prev.CC, daiSelected: dais } }))
    }

    ///Redux testing;
    const handleMessageIndexChange = (newIndex: number) => {
        setState((prev: any) => ({
            ...prev,
            messageIndex: getSafeMessageIndex(newIndex, prev.messages.length)
        }))
    }
    const handleTestReduxOnClick = () => {
        //store.dispatch({ type: 'todos/todoAdded', payload: 'Learn about actions' });
        let resultAfterDispatch = store.dispatch(login());
        console.log('CVH resultAfterDispatch', resultAfterDispatch, ' login state:', loginState)
    }
    const handleMessagesSelected: any = (msgsSelected: string[]) => {

        let tmp: any[] = []
        state.messages.map((item: number, index: any) => {
            if (msgsSelected.includes(index + ""))
                tmp.push(item);
        })
        if (tmp.length > 0)
            setState((prev: any) => ({ ...prev, messages: tmp, messageIndex: 0 }))
    }
    useEffect(() => {
        const u = GetUserFullInfo();
        if (u.suDungTinBot == 1) {
            syncTelebotMessages();
            return;
        }
        async function loadMessageFromGlobal() {
            updateMessagesFirstLoad()
        }
        loadMessageFromGlobal()
        store.dispatch(updateEditedMessageId({ editingMessageId: undefined }))
    }, [])
    function handleMienDaiCuocIdChange(e: ChangeEvent<HTMLSelectElement>) {
        const value = e.target.value
        switch (value) {
            case '0':
                setState(prev => ({ ...prev, curMien: 'ALL' }))
                break;
            case '1':
                setState(prev => ({ ...prev, curMien: 'BAC' }))
                break;
            case '2':
                setState(prev => ({ ...prev, curMien: 'TRUNG' }))
                break;
            case '3':
                setState(prev => ({ ...prev, curMien: 'NAM' }))
                break;
        }
    }
    const renderContent = () => {
        function handleCatClick(event: MouseEvent): void {
            const tmp = state.CC;
            tmp.showCatDi = !tmp.showCatDi;
            setState(prev => ({ ...prev, CC: tmp }));
        }
        const safeMessageIndex = getSafeMessageIndex(state.messageIndex, state.messages.length);
        const currentMessage = state.messages.length > 0 ? state.messages[safeMessageIndex] : undefined;

        return (<div className='xulytinnhan' id="content-screen">
            {state.activeTab == 0 && <div>

                <div className=" common-container-row padding-top">

                    {state.parsing &&
                        <div className="parsing-spinner">
                            <Loading text={`Đang phân tích, còn ${state.messages.length} tin...`}></Loading>
                        </div>
                    }
                    {state.messages.length > 0 && !state.parsing &&
                        <>
                            <Button
                                color="translucent"
                                round
                                size="smaller"
                                onClick={() => {
                                    setState((prev: any) => ({ ...prev, teleMessagesOpen: true }))

                                }}>
                                <i className="fa-solid fa-table-list"></i>
                            </Button>

                            <div>
                                {state.messageIndex + 1}/{state.messages.length}
                            </div>
                            <Button
                                color="translucent"
                                round
                                size="smaller"
                                onClick={() => {
                                    setState((prev: any) => ({ ...prev, showLuuTrongDialog: true }))
                                }}>
                                <i className="fa-solid fa-delete-left"></i>
                            </Button>
                            <Button
                                color="translucent"
                                round
                                size="smaller"
                                onClick={() => {
                                    setState((prev: any) => ({
                                        ...prev,
                                        messageIndex: getSafeMessageIndex(0, prev.messages.length)
                                    }))
                                }}>
                                <i className="fa-solid fa-backward-step"></i>
                            </Button>
                            <Button
                                color="translucent"
                                round
                                size="smaller"
                                onClick={() => {
                                    setState((prev: any) => ({
                                        ...prev,
                                        messageIndex: getSafeMessageIndex(prev.messageIndex - 1, prev.messages.length)
                                    }))
                                }}>
                                <i className="fa-solid fa-backward"></i>
                            </Button>
                            <Button
                                color="translucent"
                                round
                                size="smaller"
                                onClick={() => {
                                    setState((prev: any) => ({
                                        ...prev,
                                        messageIndex: getSafeMessageIndex(prev.messageIndex + 1, prev.messages.length)
                                    }))

                                }}>
                                <i className="fa-solid fa-forward"></i>
                            </Button>
                            <Button
                                color="translucent"
                                round
                                size="smaller"
                                onClick={() => {
                                    setState((prev: any) => ({
                                        ...prev,
                                        messageIndex: getSafeMessageIndex(prev.messages.length - 1, prev.messages.length)
                                    }))
                                }}>
                                <i className="fa-solid fa-forward-step"></i>
                            </Button>
                        </>
                    }
                </div>
                <div style="justify-content:center;text-align: center;font-weight:600; font-size:12px">
                    {currentMessage
                        ? (currentMessage.tlChatTitle + " " + getDateTimeString(currentMessage.date))
                        : ""}
                </div>
                <NhapTinNhan
                    key={currentMessage
                        ? `${currentMessage.tlChatId}:${currentMessage.tlMessageId}:${state.messages.length}`
                        : `empty:${state.messages.length}`}
                    showHeader={false} messages={state.messages} messageIndex={safeMessageIndex}
                    onTextChange={handleTextChange}
                    htmlError={currentMessage ? currentMessage.htmlError : ""}
                    errorText={currentMessage ? currentMessage.errorText : ""}
                    onUpdate={() => { }}
                    onChangeScreen={() => { }}
                    backToScreen={LotScreenSettings.CONTACT_LIST_SCREEN}
                />
            </div>}
            {/* Tab tổng hợp */}
            {(state.activeTab == 1) &&
                state.selectedReport != 'LaiLo' &&
                <div id="header-screen">
                    <TongHopDaiSelect mienDaiCuocId={getMienDaiCuocId()}
                        onGroupCuocSelected={handleGroupCuocSelected}
                        onDaiSelected={handleDaiSelected}
                        daiSelected={state.TongHopState.daiSelected}
                        onDaiLoaded={hanldeDaiLoaded}
                        groupSelected={state.TongHopState.groupSelected}
                        ngay={state.workDate}
                        onLoadReport={handleLoadReport}
                        isTongHop
                        onContactIdChanged={handleTongHopContactIdChange}
                    ></TongHopDaiSelect>

                </div>

            }
            {state.activeTab == 1 && /* tổng hợp  */
                (state.selectedReport == 'LaiLo'
                    ? <div className=" total-report-cards-container"><TotalreportAll
                        reportTotalAllData={state.reportTotalAllData} />
                    </div>
                    : <TongHopPage
                        selectedReport={state.selectedReport}
                        payload={state.reportPayload}
                        isLoading={state.isLoading}
                    ></TongHopPage>)
            }
            {/* cân chuyển  */}
            {(state.activeTab == 2) &&
                <div id="header-screen">
                    <div className="cc-send-to-ctn">
                        Chủ
                        <LotSelect value={state.CC.sendTo + ""}
                            id="sendToTelegram"
                            onChange={handleSendToTeleChange}
                            styleEx="max-width:120px"
                        >
                            {
                                state.CC.contactList.map((ct, index) => {
                                    return (<option
                                        selected={ct.contactId == state.CC.sendTo}
                                        key={"ctitem" + index} value={ct.contactId}>
                                        {ct.name}
                                    </option>)
                                })
                            }
                        </LotSelect>
                        <div className=" text-chuyen-container">
                            <input value={state.textChuyen} className="lot-input" style="width:4em;"
                                onChange={(e) => {
                                    let textChuyen = ReplaceMultipleSpaces(e.target.value);
                                    if (ValidTextChuyen(textChuyen)) {
                                        setState(prev => ({ ...prev, textChuyen: textChuyen }))
                                    } else {
                                        worker.postMessage({ type: 'showsnackbar', data: 'hãy nhập đúng định dạng 100 % hoặc 100 cho phần chuyển đi' })
                                    }

                                }}
                            ></input>
                            {!state.CC.showThamSo &&
                                <Button round size="tiny" onClick={() => { }}><i className="icon icon-open-in-new-tab"
                                    onClick={handleCatClick}
                                ></i></Button>
                            }
                        </div>
                        {!state.CC.showThamSo &&
                            <Button round size="tiny" onClick={handleCanChuyen}><i className="icon icon-send"></i></Button>
                        }

                        <div className=" form-header right-panel">
                            <Button color="translucent" size="tiny" round
                                onClick={() => {
                                    if (state.CC.sendTo <= 0) {
                                        showSnackBar("Bạn cần vào danh bạ, khai báo ít nhất 1 người là đầu chủ để chuyển đi")
                                        return
                                    }
                                    const tmp = state.CC
                                    if (!tmp.showThamSo) {
                                        tmp.showThamSo = !tmp.showThamSo;
                                        setState(prev => ({ ...prev, CC: tmp }))
                                    } else
                                        setState(prev => ({ ...prev, SaveCCParamTrigger: JSON.stringify(new Date()) }))
                                }}
                            >
                                <i className={state.CC.showThamSo ? "icon icon-stop" : "icon icon-settings"}></i>
                            </Button>
                        </div>

                    </div>
                    {!state.CC.showThamSo &&
                        <TongHopDaiSelect mienDaiCuocId={getMienDaiCuocId()}
                            onGroupCuocSelected={handleCCGroupCuocSelected}
                            onDaiSelected={handleCCDaiSelected}
                            daiSelected={state.CC.daiSelected}
                            onDaiLoaded={hanldeCCDaiLoaded}
                            groupSelected={state.CC.groupSelected}
                            ngay={state.workDate}
                            onLoadReport={handleLoadDataCanChuyen}
                        ></TongHopDaiSelect>

                    }

                    {state.CC.showThamSo &&
                        <ThamSoCanChuyen parentState={state}
                            onTabChange={handleCCTabChange}
                            onDataSaved={handleCCParamDataSaved}
                            saveDataTrigger={state.SaveCCParamTrigger}
                        ></ThamSoCanChuyen>
                    }

                </div>

            }
            {/* Tham số cân chuyển */}
            {state.activeTab == 2 && !state.CC.showThamSo && !state.isLoading &&
                <ListDataCanChuyen data={state.dataCanChuyen} />
            }
            {state.activeTab == 2 && !state.CC.showThamSo && state.isLoading &&
                <Loading />
            }

            {/* tin nhắn */}
            {state.activeTab == 3 && (
                userFullInfo.suDungTinAndroid == 1
                    ? <PhoneConvs onTransMessagesFromSelectedToParse={handleTransMessagesFromSelectedToParseAndroid} />
                    : <TeleChatList
                        parentState={state}
                        onShowSnackbar={showSnackBar}
                        onTransMessagesFromSelectedToParse={handleTransMessagesFromSelectedToParse}
                        displayType="Chat" />
            )}
            {/*đánh vào mạng ld*/}
            {state.activeTab == 4 && <One789main mainWorkingState={state} onUpdateState={handleOne789StateChanged} />}

        </div >)
    }
    useEffect(() => {
        store.dispatch(updateLastScreen(LotScreenSettings.LAM_VIEC_MIEN_BAC_SCREEN))
        const savedStr = localStorage['mainworkingState']
        if (savedStr) {
            const savedObj = JSON.parse(savedStr)

            if (savedObj) {
                setState((prev: any) => ({
                    ...prev,
                    ...savedObj,
                    workDate: store.getState().global.workDate,
                    // không khôi phục dữ liệu nặng để tránh tăng RAM khi mở lại màn hình
                    messages: [],
                    messagesFull: [],
                    messageIndex: 0,
                    parsing: false,
                    reportPayload: { data: [], mapTotal: new Map<string, any>() },
                    dataCanChuyen: getInitDataCanChuyen(),
                }));
                const mienCuPhapId = GetMienCuPhapID()
                if (mienCuPhapId == 1) {
                    setState((prev: any) => ({ ...prev, curMien: 'BAC' }));
                }
            }
        }
    }, [])
    useEffect(() => {
        saveState();
    }, [
        state.activeTab,
        state.workDate,
        state.curMien,
        state.settingDateType,
        state.loaiBoTinTrung,
        state.parseStatusMessageToLoad,
        state.khongHoiLai,
        state.autoReadMessageAfterParse,
        state.xuLyChieuTinNhan,
        state.filterCondition,
        state.TongHopState,
        state.selectedReport,
        state.CC,
        state.textChuyen,
        state.one789.giaTran,
        state.deleteDateFrom,
        state.deleteDateTo,
        state.messageDirection,
    ])
    // Tất cả các hàm call store.subscribe đều chỉ gọi 1 lần duy nhất khi nạp component, do vậy phải đưa vào useEffect
    /*     useEffect(() => {
            //tore.subscribe  trả về 1 hàm, gọi hàm này thì unsubscribe()
            const unsubscribe = store.subscribe(() => {
                setState((prevState) => ({ ...prevState, activeTab: 2 }))
                console.log('CVH sau khi dispatch, ham subcribe cua store duoc goi, update Ui')
            })
            return () => {
                unsubscribe();
                console.log('CVH store.subscribe exit useEffect')
            }
        }, []) */
    useEffect(() => {
        // GetAllMesssagesForParse(0, state.parseStatusMessageToLoad).then(result => {
        //     setState((prev: any) => ({ ...prev, messages: result, messagesFull: result }))
        // })
        readMessageToParse(1, state.workDate)
    }, [])
    function getHiddenChatIdSet(): Set<number> {
        try {
            const userInfo = GetUserFullInfo();
            const storageKey = `teleHiddenChatIds:${userInfo.username || "default"}`;
            const raw = localStorage.getItem(storageKey);
            if (!raw) return new Set<number>();
            const ids = JSON.parse(raw);
            if (!Array.isArray(ids)) return new Set<number>();
            return new Set(ids.map((id) => Number(id)).filter((id) => !Number.isNaN(id)));
        } catch {
            return new Set<number>();
        }
    }
    function readMessageToParse(messageType: number /*0,1,2*/, date: string) {
        GetAllMesssagesForParse(messageType, state.parseStatusMessageToLoad).then(result => {
            const hiddenChatIdSet = getHiddenChatIdSet();
            const tmp = result.filter(item => {
                const d = getDateString(item.date)
                if (d != date) return false;
                if (!item.tlChatId) return true;
                return !hiddenChatIdSet.has(Number(item.tlChatId));
            })
            setState((prev: any) => {
                const newState = {
                    ...prev, messages: tmp, messagesFull: tmp, messageIndex: 0,
                    filterCondition: { ...prev.filterCondition, content: "", title: "", }
                }
                return newState;
            })

        })
    }
    function handleTransMessagesFromSelectedToParse(messages: ApiMessage[]) {
        const msgs: LotMessage[] = []
        const global = getGlobal()
        messages.forEach((item: ApiMessage) => {
            if (item.content.text) {
                const text = item.content.text.text.toLowerCase()
                const chat = selectChat(global, item.chatId)
                const lmsg: LotMessage = {
                    tlChatId: Number(item.chatId),
                    tlMessageId: item.id,
                    contactId: -1, //điền sau, dựa vào các tham số khác
                    tlSenderId: Number(item.senderId),
                    body: text,
                    bodyOrigin: text,
                    date: secondsToDate(item.date),
                    type: item.isOutgoing ? 2 : 1,
                    htmlError: text,
                    errorText: "Chưa phân tích",
                    tlChatTitle: chat?.title.toLowerCase()
                }
                msgs.push(lmsg)
            }
        })

        setState((prev: any) => ({ ...prev, activeTab: 0, messagesFull: msgs, messages: msgs, messageIndex: 0 }))
    }
    function handleTransMessagesFromSelectedToParseAndroid(messages: any[]) {
        const msgs: LotMessage[] = messages
        const global = getGlobal()


        setState((prev: any) => ({ ...prev, activeTab: 0, messagesFull: msgs, messages: msgs, messageIndex: 0 }))
    }
    useEffect(() => {
        console.log('action:', menuAction)
        const actions = menuAction.split(":")
        if (actions.length > 0) {
            const action = actions[0]
            switch (action) {
                case "Parse":
                    parseMessages()
                    break;
            }
        }
    }, [menuAction])
    useEffect(() => {

        if (connectionStatus == ConnectionStatus.waitingForNetwork) {
            store.dispatch(updateNotiMessage({ message: "Mất kết nối telegram, kiểm tra mạng, tải lại trang" }))
        } else {
            store.dispatch(clearMessages({}))
        }
    }, [connectionStatus])

    useEffect(() => {
        window.addEventListener("resize", handleResize)
        return (() => {
            window.removeEventListener("resize", handleResize)
        })
    }, [])
    useEffect(() => {
        let unsubscribe;
        if (isSupported()) {
            unsubscribe = subscribe(visibility => {
                if (visibility === "hidden") {
                    // ...
                }
                else { // visibility === "visible"
                    scrollToTop()
                    //store.dispatch(updateNotiMessage({ message: `scrollToTop()` }))
                }
                //store.dispatch(updateNotiMessage({ message: `visibility:${visibility}` }))
            });

            // After calling unsubscribe() the callback will no longer be invoked.

        }
        return unsubscribe;
    }, [])
    const scrollToTop = debounce(() => {
        const element = document.getElementById("parseMessages")
        if (element) {
            element.scrollTo({ behavior: 'auto' })
        }
    }, 200)
    function handleResize() {
        //store.dispatch(updateNotiMessage({ message: `inner height:${window.innerHeight}` }))
        scrollToTop()
    }
    function getSafeMessageIndex(index: number, messagesLength: number) {
        if (messagesLength <= 0) {
            return 0;
        }
        return Math.min(Math.max(index, 0), messagesLength - 1);
    }
    function limitTextSize(input: any, maxLength: number) {
        const text = `${input ?? ""}`;
        if (text.length <= maxLength) {
            return text;
        }
        return `${text.substring(0, maxLength)}\n...[truncated ${text.length - maxLength} chars]`;
    }
    function stopParsing() {
        parseLockRef.current = false
        setState((prev: any) => ({ ...prev, parsing: false }))

        scrollToTop()
    }
    async function parseMessages() {
        if (state.messages.length <= 0) {
            return;
        }



        if (state.parsing || parseLockRef.current) {
            return;
        }
        parseLockRef.current = true
        parseSessionRef.current += 1
        const sessionId = parseSessionRef.current
        setState((prev: any) => ({ ...prev, parsing: true }))
        // duyet qua cac tin
        const start = Math.min(Math.max(state.messageIndex, 0), Math.max(state.messages.length - 1, 0));
        const workingMessages: any[] = [...state.messages];
        const workingMessagesFull: any[] = [...state.messagesFull];
        const UI_BATCH_SIZE = 20;
        const MAX_HTML_ERROR_LENGTH = 200000;
        const MAX_ERROR_TEXT_LENGTH = 20000;
        const settingDateType = state.settingDateType;
        const workDate = state.workDate;
        const xuLyChieuTinNhan = state.xuLyChieuTinNhan;
        const curMien = state.curMien;
        const loaiBoTinTrung = state.loaiBoTinTrung;
        const autoReadMessageAfterParse = state.autoReadMessageAfterParse;
        const messageDirection = state.messageDirection;
        const mapsms = new Map<string, TeleMessageToSend>()
        const clampIndex = (nextIndex: number) => {
            if (workingMessages.length <= 0) {
                return 0;
            }
            return Math.min(Math.max(nextIndex, 0), workingMessages.length - 1);
        }
        const syncUiProgress = (nextIndex: number, force = false) => {
            if (!force && nextIndex % UI_BATCH_SIZE !== 0) {
                return;
            }
            setState((prev: any) => ({
                ...prev,
                messages: [...workingMessages],
                messagesFull: [...workingMessagesFull],
                messageIndex: clampIndex(nextIndex)
            }))
        }
        let index = start;
        try {
            for (; index <= workingMessages.length - 1;) {
                if (sessionId !== parseSessionRef.current) {
                    break;
                }
                const msg: any = workingMessages[index]
                const date = msg.date
                let dateString = dateToDateString(date)
                if (settingDateType == 2) {
                    dateString = workDate
                }

                const body: LotMessage = {
                    body: msg.body,
                    bodyOrigin: msg.bodyOrigin,
                    date: dateString,
                    time: dateToTimeString(date),
                    type: xuLyChieuTinNhan == 'ALL' ? msg.type :
                        xuLyChieuTinNhan == 'DEN' ? 1 : 2,
                    contactId: msg.contactId ? msg.contactId : -1,

                    curMien: curMien,
                    getCompactData: 1,
                    getRawData: 0,
                    lockArea: curMien == "ALL" ? 0 : 1,
                    tlMessageId: msg.tlMessageId,
                    tlChatId: msg.tlChatId,
                    tlUserId: msg.tlSenderId,
                    tlChatTitle: msg.tlChatTitle,
                    editedMessageId: msg.editedMessageId || 0,
                    loaiBoTinTrung: loaiBoTinTrung
                }
                let result: any;
                if (isLocalMode()) {
                    result = await ParseAndSaveMessageLocal(body)
                }
                else {
                    result = await Parser.parseMessage(body)
                }
                let resultHtml = result.data.html
                let msgTextNotify = result.responseText
                if (msgTextNotify == "") {
                    msgTextNotify = result.data.totalErrorText
                }
                if (resultHtml == "")
                    resultHtml = result.data.bodyViet
                workingMessages[index].htmlError = limitTextSize(resultHtml, MAX_HTML_ERROR_LENGTH)
                workingMessages[index].errorText = limitTextSize(msgTextNotify, MAX_ERROR_TEXT_LENGTH)
                syncUiProgress(index + 1)
                if (result.errorCode == 0 && result.data.parseStatus == "parseOK") {
                    msgTextNotify = result.data.responseText
                    workingMessages[index].errorText = limitTextSize(msgTextNotify, MAX_ERROR_TEXT_LENGTH)
                    const processedIndex = index
                    syncUiProgress(processedIndex)
                    if (DEBUG)
                        console.log("Thành công:" + msg.body)
                    if (body.editedMessageId == 0) {
                        MarkMessageParsed(body)
                    }
                    if (result.data.traLai && result.data.traLai.length > 0) {
                        if (isLocalMode()) {
                            const sms = BuildSMSTraLaiMB(result.data.traLai)
                            SendTeleMessage(sms, msg.tlChatId, sendMessage)
                        } else {
                            const sms = result.data.traLaiSoVuot
                            SendTeleMessage(sms, msg.tlChatId, sendMessage)
                        }
                    }
                    if (result.data.tongSoTinDen > 0) {

                        const newMsg: TeleMessageToSend = {
                            message: `#wapp: nhận ${result.data.tongSoTinDen} tin`,
                            chatId: msg.tlChatId
                        }
                        mapsms.set(msg.tlChatId, newMsg)

                        DebounceKhopTin(mapsms, sendMessage)
                    }
                    if (result.data.tinTraLaiQuaGio && result.data.tinTraLaiQuaGio.length > 0) {
                        const text = result.data.totalErrorText + result.data.tinTraLaiQuaGio
                        SendTeleMessage(`${text}`, msg.tlChatId, sendMessage)
                    }
                    const fullIndex = workingMessagesFull.findIndex((it: any) =>
                        it.tlMessageId == msg.tlMessageId && it.tlChatId == msg.tlChatId
                    )
                    if (fullIndex >= 0) {
                        workingMessagesFull.splice(fullIndex, 1)
                    }
                    // Parse xong là xóa luôn để giải phóng RAM, xử lý tiếp tin kế bên.
                    workingMessages.splice(processedIndex, 1)
                    // Không tăng index: phần tử kế tiếp đã dồn vào đúng vị trí processedIndex.
                    syncUiProgress(processedIndex, true)
                    if (workingMessages.length <= 0 && autoReadMessageAfterParse) {
                        // tự động  đọc tin nhắn sau khi phân tích xong tất cả tin
                        setTimeout(() => {
                            readMessageToParse(messageDirection, workDate)
                        }, 200);

                    }
                } else {
                    if (DEBUG)
                        console.log("Lỗi phân tích:" + msg.body)
                    syncUiProgress(index + 1, true)
                    break;
                }
                await sleep(100)
            }
        } finally {
            parseLockRef.current = false
        }
        syncUiProgress(index, true)
        stopParsing()
        return;
    }

    function showSnackBar(message: string) {
        setState(prev => ({ ...prev, snackbarMessage: message, snackbarOpen: true }))
    }
    function handleTextChange(htmlText: string, rawText: string) {
        if (state.messages.length <= 0)
            return;
        const safeIndex = getSafeMessageIndex(state.messageIndex, state.messages.length);
        let tmp: any[] = [...state.messages]
        tmp[safeIndex].body = rawText
        // chỗ này nếu để thì sẽ bị mỗi lần gõ phím sẽ nhảy về đầu ô text edit
        //tmp[safeIndex].htmlError = htmlText

        setState((prev: any) => ({ ...prev, messages: tmp, messageIndex: safeIndex }))
        return;
    }
    //debounce search

    const debouncedSetFilter = debounce((value: string) => {
        // Thực hiện các tác vụ tìm kiếm hoặc xử lý dữ liệu với giá trị value
        if (DEBUG)
            console.log("search for:", value)
        setFilter(value)
    }, 500);

    const handleSearchQuery = (query: string) => {

        debouncedSetFilter(query)
    }
    const handleFilter = (query: any) => {
        let { title, content, date } = query;
        title = title.toLowerCase();
        content = content.toLowerCase()
        setState((prev: any) => ({ ...prev, filterMessagesOpen: false }))
        const filtered = state.messagesFull.filter((item: any) => {
            let ok = true;
            if (item?.tlChatTitle == undefined || item?.tlChatTitle && item?.tlChatTitle.includes(title)) { }
            else {
                ok = false;
                if (DEBUG) {
                    console.log("!item?.tlChatTitle.includes(title)", item)
                }
            }
            if (item.body.includes(content)) { }
            else {
                ok = false;
                if (DEBUG) {
                    console.log("!item.body.includes(content)", item)
                }

            }
            return ok

        })
        if (filtered.length > 0) {
            setState((prev: any) => ({
                ...prev, messages: filtered, messageIndex: 0,
                filterCondition: { title: title, content: content, date: date }
            }))
        }
        else
            showSnackBar("Không tìm thấy tin nhắn thoả mãn.")
        return;
    }
    function setFilter(filter: string) {
        const global = getGlobal()
        const filterLowerCase = filter.toLowerCase()
        const filtered = state.messagesFull.filter((item: any) => {
            let ok = true;
            // lọc trước theo điều kiệm lọc tin nhắn sau đó tìm tiếp
            const title = state.filterCondition.title;
            const content = state.filterCondition.content
            if (item?.tlChatTitle == undefined || item?.tlChatTitle && item?.tlChatTitle.includes(title)) { }
            else
                ok = false;
            if (ok && item.body.includes(content)) { }
            else
                ok = false;
            if (ok) {
                if (item?.tlChatTitle && item?.tlChatTitle.includes(filterLowerCase))
                    return true;
                if (item.body.includes(filterLowerCase))
                    return true;
            }
            return false

        })
        if (filtered.length > 0)
            setState((prev: any) => ({ ...prev, messages: filtered, messageIndex: 0, filter: filter }))
    }
    function handleSettingDialogClosed() {

        setState(prev => ({ ...prev, settingOpen: false }))
        if (state.sourceActiveSettingDialog != 0)
            parseMessages()

    }
    function handleBeforeParse() {
        if (state.khongHoiLai)
            parseMessages()
        else
            setState(prev => ({ ...prev, sourceActiveSettingDialog: 1, settingOpen: true }))
    }
    function handleFilterChange(payload: any) {
        const { title, content } = payload;
        let newState = state.filterCondition;
        newState = { ...newState, title: title, content: content }
        setState(prev => ({
            ...prev, filterCondition: newState
        }))
    }
    function markLuuTinTrong() {
        if (state.messages.length <= 0) {
            return;
        }
        const safeIndex = getSafeMessageIndex(state.messageIndex, state.messages.length)
        const curMsg: LotMessage = state.messages[safeIndex]
        const apiMessages: ApiMessage[] = [{
            id: curMsg.tlMessageId,
            chatId: curMsg.tlChatId + "",
            content: { text: { text: curMsg.body } },
            date: curMsg.date.getTime() / 1000,
            isOutgoing: curMsg.type === 2
        }]
        LuuTrongTinNhan(apiMessages)

        const filteredMessages = state.messages.filter((msg: LotMessage) => {
            return !(msg.tlMessageId == curMsg.tlMessageId && msg.tlChatId == curMsg.tlChatId)
        })
        const filteredMessagesFull = state.messagesFull.filter((msg: LotMessage) => {
            return !(msg.tlMessageId == curMsg.tlMessageId && msg.tlChatId == curMsg.tlChatId)
        })
        let index = safeIndex
        if (index > filteredMessages.length - 1)
            index -= 1;
        if (index < 0)
            index = 0;
        setState(prev => ({
            ...prev, messages: filteredMessages,
            messagesFull: filteredMessagesFull, messageIndex: index
        }))
    }
    /////BÁo cáo
    async function handleLoadReport(selectedReport?: ReportType, curMien?: string) {
        let temp: any;
        const selectedRerport = selectedReport ? selectedReport : tongHopSlice.selectedReport;
        const mienDaiCuocId = curMien ? getMienDaiCuocId(curMien) : getMienDaiCuocId()
        let params: RptNhanVeParamsType = {
            selectedReport: selectedRerport,
            ngay: state.workDate,
            mienDaiCuocId: mienDaiCuocId,
            contactId: state.TongHopState.contactId, // tạm thời để =0 để test
            daiIds: state.TongHopState.daiSelected,
            loaiCuocIds: GetLoaiCuocIdsFromGroups(state.TongHopState.groupSelected)
        }
        if (selectedReport) {
            params.selectedReport = selectedReport;
        }
        let result: any;
        switch (params.selectedReport) {
            case 'NhanVe':
                setState(prev => ({ ...prev, isLoading: true }))
                result = await TongHopReport.FetchNhanVe(params)
                break;
            case 'ChuyenDi':
                setState(prev => ({ ...prev, isLoading: true }))
                result = await TongHopReport.FetchChuyenDi(params)
                break;
            case 'GiuLai':
                setState(prev => ({ ...prev, isLoading: true }))
                result = await TongHopReport.FetchGiuLai(params)
                break;
            case 'LaiLo':
                if (mienDaiCuocId == 0) {
                    showSnackBar('Báo cáo này cần chọn miền cụ thể: MB, MT, MN')
                    return;
                }
                setState(prev => ({ ...prev, isLoading: true }))
                temp = await TongHopReport.FetchLaiLo(params)
                setState(prev => ({ ...prev, selectedReport: params.selectedReport, isLoading: false, reportTotalAllData: temp }))

                break;
        }
        if (result) {
            store.dispatch(updateRptDetailsData(result))
            const tmp = { ...state.reportPayload }
            const [data, mapTotal] = sortData(result.data);

            //sắp xếp và tính tổng theo từng đài,loại
            setState(prev => ({
                ...prev, selectedReport: params.selectedReport, isLoading: false,
                reportPayload: { ...tmp, data: data, mapTotal: mapTotal }
            }))
        }


    }
    function sortData(data: any[]): [any[], Map<string, number>] {
        if (!data) return [[], new Map()];
        const result = data.filter((item) => {
            return item.sumDiem != 0;
        });
        result.sort((a: any, b: any) => {
            if (a.daiId1 !== b.daiId1) {
                if (a.daiId1 > b.daiId1)
                    return 1;
                else if (a.daiId1 < b.daiId1)
                    return -1;
                else
                    return 0;

            }


            if (a.daiId2 !== b.daiId2) {
                if (a.daiId2 > b.daiId2)
                    return 1;
                else if (a.daiId2 < b.daiId2)
                    return -1;
                else
                    return 0;

            }


            if (a.loaiCuocId !== b.loaiCuocId) {
                if (a.loaiCuocId > b.loaiCuocId)
                    return 1;
                else if (a.loaiCuocId < b.loaiCuocId)
                    return -1;
                else
                    return 0;

            }


            if (a.sumDiem !== b.sumDiem) {
                if (b.sumDiem > a.sumDiem)
                    return 1;
                else if (b.sumDiem < a.sumDiem)
                    return -1;
                else
                    return 0;
            }



            if (a.soCuoc > b.soCuoc)
                return 1;
            else if (a.soCuoc < b.soCuoc)
                return -1;
            else
                return 0;
        })
        let preLoaiCuoc = '';
        let stt = 1;
        let mapTotal: Map<string, number> = new Map();
        const length = result.length;
        for (let index = 0; index < length; index++) {
            const item = { ...result[index] };
            result[index] = item; //tạo đối tượng mới, thay thế cho đối tượng cũ
            if (index == length - 1)
                item['lastItem'] = true;
            else
                item['lastItem'] = false;
            if (item.loaiCuocId != preLoaiCuoc) {

                if (stt == length) {
                    item['lastItem'] = true;
                } else if (preLoaiCuoc != '') {
                    result[index - 1]['lastItem'] = true;
                }
                stt = 1;
            }
            else {
                stt++;
            }
            preLoaiCuoc = item.loaiCuocId;
            //
            item['stt'] = stt;
            // add to map
            const key = `${item.daiId1}.${item.daiId2}:${item.loaiCuocId}`;
            let mapItem = mapTotal.get(key);
            if (mapItem == undefined || mapItem == null) {
                mapItem = item.sumDiem;
            } else {
                mapItem += item.sumDiem;
            }
            mapTotal.set(key, mapItem!);
        }
        return [result, mapTotal];
    }
    ///CÂN CHUYỂN
    useEffect(() => {
        GetContactsToSend().then(cts => {
            const CC = state.CC
            CC.contactList = cts;
            let sendTo = -1
            if (cts.length > 0) {
                sendTo = cts[0].contactId
            }
            CC.sendTo = sendTo;
            setState(prev => ({ ...prev, CC: CC }))
        })
    }, [])
    function handleSendToTeleChange(e: any) {
        const contactId = Number(e.target.value)
        const CC = state.CC
        CC.sendTo = contactId
        setState(prev => ({ ...prev, CC: CC }))
    }

    function handleCCTabChange(tab: number) {
        const tmp = state.CC;
        tmp.activeTab = tab;
        setState(prev => ({ ...prev, CC: tmp }))
    }
    function handleCCParamDataSaved() {
        const tmp = state.CC
        tmp.showThamSo = false;
        setState(prev => ({ ...prev, CC: tmp, SaveCCParamTrigger: "" }))

    }
    function handleLoadDataCanChuyen() {
        const daiList = state.CC.daiSelected.join(",")
        const loaiCuocList = GetLoaiCuocIdsFromGroups(state.CC.groupSelected).join(",")
        const date = state.workDate
        const userId = Number(localStorage["userId"])
        const contactId = state.CC.sendTo
        const payload = { daiList, userId, date, loaiCuocList, contactId }
        setState(prev => ({ ...prev, isLoading: true }))
        CanChuyen.getDataCanChuyen(payload).then((result: any) => {
            //console.log(result)
            const tmp = result?.data

            if (tmp != null) {
                buildGiuLaiNgoaiLe(tmp)
                if (tmp.foundStt != null && JSON.stringify(tmp.foundStt) != "{}") {
                    buildDiemByStt(tmp)

                }
                sortDataCanChuyen(tmp)


                setState(prev => ({ ...prev, dataCanChuyen: tmp, isLoading: false }))
            }
            else
                setState(prev => ({ ...prev, isLoading: false, dataCanChuyen: getInitDataCanChuyen() }))
        })
    }
    function getInitDataCanChuyen(): any {
        const giuLaiNgoaiLe: GiuLaiNgoaiLe = initGiuLaiNgoaiLe()
        return { dataCanChuyenStruct: [], diemByStt: {}, giuLaiNgoaiLe: giuLaiNgoaiLe }
    }
    function handleCanChuyen(buildSmss: boolean = true, smss: string[] = []) {
        let mapResult;
        if (buildSmss) {
            [smss, mapResult] = buildSms(state.dataCanChuyen, state.textChuyen);
        }
        const contactId = state.CC.sendTo
        const date = state.workDate
        const payload = { contactId, date }
        const tmp = state.CC
        tmp.showCatDi = false;
        setState(prev => ({ ...prev, CC: tmp }))
        CanChuyen.getCountTinChuyenDi(payload).then((data: any) => {
            let sotin = Number(data.data) + 1;
            for (let i = 0; i < smss.length; i++) {
                smss[i] = "tin" + (sotin++) + ": " + smss[i];
            }

            tmp.messages = smss
            setState(prev => ({ ...prev, CC: tmp }))
            if (smss.length > 0) {
                tmp.sendMessagesOpen = true
                setState(prev => ({ ...prev, CC: tmp }));
            } else {
                worker.postMessage({ type: 'showsnackbar', data: 'Không có số liệu' });
            }

        })
    }
    function handleOnPlayOne789(mapResult: Map<string, any>) {
        // const playdata = buildPlayData(
        //     0, One789BetTypes.De, mapResult
        // )
        // console.log(playdata);
        if (DEBUG)
            console.log('handleOnPlayOne789');
        setState(prev => ({
            ...prev, activeTab: 4,
            CC: { ...prev.CC, showCatDi: false },
            one789: { ...prev.one789, mapResult: mapResult }
        }))

    }
    function handleOnPlayOne789TuyChon(mapResult: Map<string, any>) {

        if (DEBUG)
            console.log('handleOnPlayOne789');
        setState(prev => ({
            ...prev, activeTab: 4,
            CC: { ...prev.CC, showCatDi: false, sendMessagesOpen: false },
            one789: { ...prev.one789, mapResult: mapResult }
        }))

    }
    function handleDeleteDateChange(value: string, fieldName: 'from' | 'to') {
        if (fieldName == 'from') {
            setState(prev => ({ ...prev, deleteDateFrom: value }))
        } else if (fieldName == 'to') {
            setState(prev => ({ ...prev, deleteDateTo: value }))
        }
    }
    function handleGetTestMessage(payload: any) {
        AdminApi.GetTestMessages(payload).then((result: any) => {
            const msgs: LotMessage[] = []
            const global = getGlobal()
            const curContact: any = store.getState().contact.currentContact;
            if (curContact == null || curContact == undefined) {
                showSnackBar("Hãy vào danh bạ chọn 1 người để phân tích cho người đó")
                return;
            }
            result.data.forEach((item: any) => {

                const text = item.body

                const lmsg = {
                    bodyOrigin: text,
                    body: text,
                    date: new Date(),
                    time: getCurrentTime(),
                    type: 1,
                    contactId: curContact!.contactId,
                    curMien: state.curMien,
                    getCompactData: 1,
                    getRawData: 0,
                    lockArea: 1,
                    tlChatTitle: curContact.name,
                    tlChatId: 0,
                    tlMessageId: 0,

                    tlSenderId: 0,


                    htmlError: text,
                    errorText: "Chưa phân tích",


                }
                msgs.push(lmsg)

            })

            setState((prev: any) => ({ ...prev, activeTab: 0, messagesFull: msgs, messages: msgs, messageIndex: 0 }))
        })
    }
    function handleGetParsedMessage(payload: any) {
        AdminApi.GetParsedMessages(payload).then((result: any) => {
            const msgs: LotMessage[] = []
             
            const curContact: any = store.getState().contact.currentContact;
            if (curContact == null || curContact == undefined) {
                showSnackBar("Hãy vào danh bạ chọn 1 người để phân tích cho người đó")
                return;
            }
            result.data.forEach((item: any) => {

                const text = item.body ?? item.bodyOrigin ?? item.originBody ?? ""

                const lmsg = {
                    bodyOrigin: text,
                    body: text,
                    date: new Date(),
                    time: getCurrentTime(),
                    
                    contactId: curContact!.contactId,
                    curMien: state.curMien,
                    getCompactData: 1,
                    getRawData: 0,
                    lockArea: 1,
                    tlChatTitle: curContact.name,
                    tlChatId: item.chatId,
                    tlMessageId: item.tlMessageId,

                    tlSenderId: item.tlSenderId,


                    htmlError: text,
                    errorText: "Chưa phân tích",
                    editedMessageId: item.editedMessageId,
                    type: item.type,


                }
                msgs.push(lmsg)

            })

            setState((prev: any) => ({ ...prev, activeTab: 0, messagesFull: msgs, messages: msgs, messageIndex: 0 }))
        })
    }
    return (
        <div id="MainIlotteryVN" className=" form-main" style='max-width:700px;'>
            {!state.teleMessagesOpen && <div className="main-working-header">
                <div className="left-panel">
                    <Button
                        round
                        size="default"
                        color="translucent"
                        onClick={() => onChangeScreen(LotScreenSettings.CONTACT_LIST_SCREEN)}
                    //className={buildClassName(styles.headerButton, styles.firstButton)}
                    //ariaLabel={lang(isFullscreen ? 'AccExitFullscreen' : 'AccSwitchToFullscreen')}
                    >
                        <i
                            className='icon icon-arrow-left'
                            aria-hidden
                        />
                    </Button>

                    <div className="divider"></div>
                    <input id="basic-report-date" type="date" className="date-input item" value={state.workDate}
                        pattern="\d{2}/\d{2}/\d{4}" placeholder="dd/mm/yyyy"

                        onChange={(e) => {
                            const tmp = state.CC
                            tmp.showThamSo = false;
                            setState((prev: any) => ({ ...prev, workDate: e.target.value, CC: tmp }))
                            store.dispatch(updateWorkDate({ workDate: e.target.value }))
                        }
                        }
                    />
                    <div className="divider"></div>
                    {isCuPhapMn() &&
                        <LotSelect value={state.curMien} id="cur-mien"
                            onChange={(e) => {
                                const tmp = state.CC
                                tmp.showThamSo = false;
                                setState((prev: any) => ({ ...prev, curMien: e.target.value, CC: tmp }))

                                if (state.activeTab == 1) {
                                    handleLoadReport(state.selectedReport, e.target.value)
                                }
                            }}>
                            <option value="NAM" selected={state.curMien == "NAM"}>MN</option>
                            <option value="TRUNG" selected={state.curMien == "TRUNG"}>MT</option>
                            <option value="BAC" selected={state.curMien == "BAC"}>MB</option>
                            <option value="ALL" selected={state.curMien == "ALL"}>Ba miền</option>
                        </LotSelect>
                    }
                    {
                        state.activeTab == 1 && <div className="nhan-chuyen-caption">
                            {(() => {
                                let ret = '';
                                switch (tongHopSlice.selectedReport) {
                                    case 'NhanVe':
                                        ret = "Nhận";
                                        break;
                                    case 'ChuyenDi':
                                        ret = "Chuyển";
                                        break;
                                    case 'GiuLai':
                                        ret = "Giữ";
                                        break;
                                    case 'LaiLo':
                                        ret = "Lãi lỗ";
                                        break;
                                }
                                return ret;
                            })()}
                        </div>
                    }

                </div>
                {/* Tab xử lý */}
                {state.activeTab == 0 &&

                    <Button round
                        size="default"
                        color="translucent"
                        onClick={handleBeforeParse}
                        id="parseMessages"
                        disabled={state.parsing}
                    >
                        <i className={"fa-regular fa-floppy-disk  fa-xl fa-beat"}></i>
                    </Button>
                }
                {/* {
                    state.parsing && <div style="padding:0 0.75rem 0 0"
                        onClick={() => {
                            setState((prev: any) => ({
                                ...prev, parsing: false
                            }))
                        }}
                    > <LotSpinner /> </div>
                } */}
                {/* Tab xử lý */}
                {state.activeTab == 0 &&
                    <DropdownMenu positionX="right">
                        <MenuItem onClick={() => {
                            setState((prev: any) => ({ ...prev, messageDirection: 1, }))
                            readMessageToParse(1, state.workDate)
                        }} icon='send-outline'>
                            Đọc tin đến
                        </MenuItem>
                        <MenuItem onClick={() => {
                            setState((prev: any) => ({ ...prev, messageDirection: 2, }))
                            readMessageToParse(2, state.workDate)
                        }} icon='icon icon-email'>
                            Đọc tin đi
                        </MenuItem>
                        <MenuItem onClick={() => {
                            setState((prev: any) => ({ ...prev, filterMessagesOpen: true }))
                        }}
                            icon='icon icon-search'
                        >
                            Lọc tin nhắn
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                setState((prev: any) => ({ ...prev, settingOpen: true, sourceActiveSettingDialog: 0 }))
                            }}
                            icon='icon icon-settings'
                        >
                            Cài đặt tham số phân tích
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                setState((prev: any) => ({ ...prev, deleteDialogOpen: true }))
                            }}
                            icon='icon icon-delete'
                        >
                            Xoá toàn bộ số liệu đã phân tích
                        </MenuItem>
                        {hasRightGetTestMessage() &&
                            <MenuItem
                                onClick={() => {
                                    setState((prev: any) => ({ ...prev, getTestMessageDialogOpen: true }))
                                }}
                                icon='icon icon-reload'
                            >
                                Lấy tin chạy thử
                            </MenuItem>
                        }
                        <MenuItem
                                onClick={() => {
                                    setState((prev: any) => ({ ...prev, getParsedMessageDialogOpen: true }))
                                }}
                                icon='icon icon-file-text'
                            >
                                Lấy tin phân tích lại
                            </MenuItem>
                        <MenuItem
                            onClick={() => {
                                store.dispatch(updateNotiMessage({ message: "Đang đồng bộ tin nhắn" }))
                                FetchAllChatAndSaveToLocal()
                                FetchAllMessageAndSaveToLocal()
                            }}
                            icon='icon icon-reload'
                        >
                            Đồng bộ tin nhắn telegram
                        </MenuItem>
                        {GetUserID() == '50' &&
                            <MenuItem
                                onClick={() => {
                                    GenerateDataForTestMb()
                                }}
                                icon='icon icon-reload'
                            >
                                Tesst
                            </MenuItem>
                        }
                    </DropdownMenu>
                }
                {/* Tab tổng hợp */}
                {state.activeTab == 1 &&
                    <DropdownMenu positionX="right">
                        <MenuItem className="selected"
                            icon={tongHopSlice.selectedReport == 'NhanVe' ? "icon icon-check" : ""}
                            onClick={() => {
                                store.dispatch(selectReport({ selectedReport: 'NhanVe' }))
                                handleLoadReport('NhanVe')
                            }}>
                            Nhận về
                        </MenuItem>
                        <MenuItem
                            icon={tongHopSlice.selectedReport == 'ChuyenDi' ? "icon icon-check" : ""}
                            onClick={() => {
                                store.dispatch(selectReport({ selectedReport: 'ChuyenDi' }))
                                handleLoadReport('ChuyenDi')
                            }}>
                            Chuyển đi
                        </MenuItem>
                        <MenuItem
                            icon={tongHopSlice.selectedReport == 'GiuLai' ? "icon icon-check" : ""}
                            onClick={() => {
                                store.dispatch(selectReport({ selectedReport: 'GiuLai' }))
                                handleLoadReport('GiuLai')
                            }}>
                            Giữ lại
                        </MenuItem>
                        <MenuItem
                            icon={tongHopSlice.selectedReport == 'LaiLo' ? "icon icon-check" : ""}
                            onClick={() => {
                                store.dispatch(selectReport({ selectedReport: 'LaiLo' }))
                                handleLoadReport('LaiLo')
                            }}>
                            Lãi lỗ
                        </MenuItem>
                    </DropdownMenu>
                }
                {/* {
                    state.isSaving && <div style="padding:0 0.75rem 0 0"> <LotSpinner /> </div>
                } */}
            </div>
            }
            <TabList tabs={tabs} activeTab={state.activeTab} onSwitchTab={
                (index) => {
                    setState({ ...state, activeTab: index })
                    // sqliteWorker.postMessage({ data: "CVH datas", action: "CVH load contact", state: { ...state, activeTab: index } })

                }
            }></TabList>

            {state.tabData && !state.teleMessagesOpen && renderContent()}


            <TeleMessages isOpen={state.teleMessagesOpen} messages={state.messages}
                messageIndex={getSafeMessageIndex(state.messageIndex, state.messages.length)}
                onClose={() => {
                    setState((prev: any) => ({ ...prev, teleMessagesOpen: false }))
                }}
                onMessagesSelect={handleMessagesSelected}
                onIndexChange={handleMessageIndexChange}
                onSearchChange={handleSearchQuery}
                filter={state.filter}
            ></TeleMessages>
            <FilterMessage isOpen={state.filterMessagesOpen} messages={state.messages}
                messageIndex={getSafeMessageIndex(state.messageIndex, state.messages.length)}
                onClose={() => {
                    setState((prev: any) => ({ ...prev, filterMessagesOpen: false }))
                }}
                onMessagesSelect={handleMessagesSelected}
                onIndexChange={handleMessageIndexChange}
                onSearchChange={handleFilter}
                filter={state.filter}
                title={state.filterCondition.title}
                content={state.filterCondition.content}
                onFilterChange={handleFilterChange}
            ></FilterMessage>
            <ConfirmDialog isOpen={state.settingOpen}
                isOnlyConfirm
                title="Tham số phân tích tin"
                confirmLabel={state.sourceActiveSettingDialog == 0 ? "Đóng" : "Phân tích"}
                onClose={() => { setState((prev: any) => ({ ...prev, settingOpen: false })) }}
                confirmHandler={() => { handleSettingDialogClosed() }}>
                <div style="gap:10px;">
                    <div className=" common-container-row">
                        <div >Miền đài cược</div>
                        <LotSelect value={state.curMien} id="cur-mien"
                            onChange={(e) => {
                                setState((prev: any) => ({ ...prev, curMien: e.target.value }))
                            }}>
                            <option value="NAM" selected={state.curMien == "NAM"}>MN</option>
                            <option value="TRUNG" selected={state.curMien == "TRUNG"}>MT</option>
                            <option value="BAC" selected={state.curMien == "BAC"}>MB</option>
                        </LotSelect>
                    </div>

                    <LotCheckBox text="Lấy ngày của tin nhắn"
                        checked={state.settingDateType == 1}
                        onChange={(e) => {
                            if (e.target.checked) {
                                setState((prev: any) => ({ ...prev, settingDateType: 1 }))
                            } else
                                setState((prev: any) => ({ ...prev, settingDateType: 2 }))
                        }}
                    ></LotCheckBox>
                    <LotCheckBox text="Lấy ngày do bạn thiết lập"

                        checked={state.settingDateType == 2}
                        onChange={(e) => {
                            if (e.target.checked) {
                                setState((prev: any) => ({ ...prev, settingDateType: 2 }))
                            } else
                                setState((prev: any) => ({ ...prev, settingDateType: 1 }))
                        }}></LotCheckBox>
                    <LotCheckBox text="Loại bỏ tin trùng nhau"

                        checked={state.loaiBoTinTrung == 1}
                        onChange={(e) => {
                            if (e.target.checked) {
                                setState((prev: any) => ({ ...prev, loaiBoTinTrung: 1 }))
                            } else
                                setState((prev: any) => ({ ...prev, loaiBoTinTrung: 0 }))
                        }}></LotCheckBox>
                    <LotCheckBox text="Chỉ nạp các tin chưa phân tích"

                        checked={state.parseStatusMessageToLoad == 0}
                        onChange={(e) => {
                            if (e.target.checked) {
                                setState((prev: any) => ({ ...prev, parseStatusMessageToLoad: 0 }))
                            } else
                                setState((prev: any) => ({ ...prev, parseStatusMessageToLoad: 2 }))
                        }}></LotCheckBox>
                    <LotSelect value={state.xuLyChieuTinNhan} id="xuLyChieuTinNhan"
                        onChange={(e) => {
                            setState((prev: any) => ({ ...prev, xuLyChieuTinNhan: e.target.value }))
                        }}>
                        <option value="ALL" selected={state.xuLyChieuTinNhan == "ALL"}>Tin đến tính là khách, tin đi là chủ</option>
                        <option value="DI" selected={state.xuLyChieuTinNhan == "DI"}>Tính là chủ</option>
                        <option value="DEN" selected={state.xuLyChieuTinNhan == "DEN"}>Tính là khách</option>
                    </LotSelect>
                    <LotCheckBox text="Tự động đọc tin sau khi phân tích"
                        checked={state.autoReadMessageAfterParse}
                        onChange={(e) => {
                            if (e.target.checked) {
                                setState((prev: any) => ({ ...prev, autoReadMessageAfterParse: true }))
                            } else
                                setState((prev: any) => ({ ...prev, autoReadMessageAfterParse: false }))
                        }}
                    ></LotCheckBox>
                    <LotCheckBox text="Không hỏi lại lần sau"

                        checked={state.khongHoiLai}
                        onChange={(e) => {
                            if (e.target.checked) {
                                setState((prev: any) => ({ ...prev, khongHoiLai: true }))
                            } else
                                setState((prev: any) => ({ ...prev, khongHoiLai: false }))
                        }}></LotCheckBox>

                </div>
            </ConfirmDialog>
            <ConfirmDialog title="Xoá toàn bộ số liệu"
                isOpen={state.deleteDialogOpen}
                onClose={() => { setState((prev: any) => ({ ...prev, deleteDialogOpen: false })) }}
                confirmLabel="Xoá"
                confirmHandler={() => {
                    setState((prev: any) => ({ ...prev, deleteDialogOpen: false }))
                    if (isLocalMode()) {
                        globalDexieDb.messageDetails.clear()
                        globalDexieDb.dbmessages.clear()
                        MarkAllmessagesNotParsed()
                    } else {
                        const payload = { ngay: state.deleteDateFrom, denNgay: state.deleteDateTo }
                        Parser.deleteAllDataByDateRange(payload).then(result => {
                            showSnackBar(result.responseText)
                            MarkAllmessagesNotParsed()
                        })
                    }
                }
                }
            >
                <div style='gap:10px;'>
                    <MyDateInput value={state.deleteDateFrom} onChange={function (e: React.ChangeEvent<HTMLInputElement>): void {
                        handleDeleteDateChange(e.target.value, 'from');
                    }} label={" Từ ngày"} labelPosition={"top"} />
                    <div style='height:10px'></div>
                    <MyDateInput value={state.deleteDateTo} onChange={function (e: React.ChangeEvent<HTMLInputElement>): void {
                        handleDeleteDateChange(e.target.value, 'to');
                    }} label={"Đến ngày"} labelPosition={"top"} />
                </div>
            </ConfirmDialog>
            <ConfirmDialog
                title="Xác nhận loại bỏ tin"
                text="Loại bỏ tin nhắn hiện tại, xoá số liệu và đánh dấu không nạp tin nhắn này khi đọc tin phân tích?"
                confirmLabel="Loại bỏ"
                isOpen={state.showLuuTrongDialog}
                onClose={() => (setState(prev => ({ ...prev, showLuuTrongDialog: false })))}
                confirmHandler={() => {
                    setState(prev => ({ ...prev, showLuuTrongDialog: false }))
                    markLuuTinTrong()
                }}
            >

            </ConfirmDialog>
            <Snackbar isOpen={state.snackbarOpen} triggerTime={JSON.stringify(new Date())}
                message={state.snackbarMessage}
                onClose={() => {
                    setState(prev => ({ ...prev, snackbarOpen: false }))

                }}
            ></Snackbar>
            <SendMessages
                isOpen={state.CC.sendMessagesOpen}
                onClose={() => {
                    const tmp = state.CC
                    tmp.sendMessagesOpen = false;
                    setState(prev => ({ ...prev, CC: tmp }))
                }}
                messages={state.CC.messages}
                sendTo={state.CC.sendTo}
                parentState={state}
            ></SendMessages>
            <DialogCatChuyenDi textChuyen="" isOpen={state.CC.showCatDi}
                onSmssReady={(smss: string[]) => { handleCanChuyen(false, smss) }}
                dataCanChuyen={state.dataCanChuyen}
                chuId={state.CC.sendTo}
                onClose={() => {
                    setState(prev => ({ ...prev, CC: { ...prev.CC, showCatDi: false } }));
                }}
                onPlayOne789={handleOnPlayOne789}
                onPlayOne789TuyChon={handleOnPlayOne789TuyChon}
            ></DialogCatChuyenDi>
            <DialogGetTestMessage
                isOpen={state.getTestMessageDialogOpen}
                onClose={() => {
                    setState(prev => ({ ...prev, getTestMessageDialogOpen: false }))
                }}
                onConfirm={(payload) => {
                    setState(prev => ({ ...prev, getTestMessageDialogOpen: false }))
                    handleGetTestMessage(payload)

                    //GetTestMessage()
                }}
            ></DialogGetTestMessage>
            <DialogGetParsedMessage
                isOpen={state.getParsedMessageDialogOpen}
                onClose={() => {
                    setState(prev => ({ ...prev, getParsedMessageDialogOpen: false }))
                }}
                onConfirm={(payload) => {
                    setState(prev => ({ ...prev, getParsedMessageDialogOpen: false }))
                    handleGetParsedMessage(payload)
                }}
            ></DialogGetParsedMessage>
        </div >
    )
}
export default memo(MainWorking)
